import ProductListTab from './ProductListTab';

export default ProductListTab;
